const l10n: I18NCookieSetLayerTextData = {

        "confirmToast":{
        "content": "NC 安全地管理您的个人信息。<br>我们使用 cookie 和其他跟踪技术来提高网站性能，并根据您的偏好提供广告，同时存储您的相关信息以进行流量分析和访客统计，以不断改进我们的服务。<br>\单击“全部接受\”，即表示您同意存储您的设备 cookie；单击\“全部拒绝\”，将不会存储除必要 cookie 之外的所有 cookie。您可以<br>随时通过<a href=\"#\">Cookie 政策</a>查看详细信息并更改或撤回同意。",
        "BtnApply": "全部同意",
        "BtnDeny": "全部拒绝",
        "BtnApplyOptional": "部分同意",
        "BtnSetting": "设置"
    },
    "settingModal":{
      "msgSuccess": "",
      "titleLayer": "",
      "topDesc": "",
      "chkRequired": "",
      "chkOptional": "",
      "chkOptional2": "",
      "chkOptional3": "",
      "btnApply": "",
      "tabRequired": "",
      "tabOptional": "",
      "tabOptional2": "",
      "tabOptional3": "",
      "requiredDesc": "",
      "optionalDesc": "",
      "optional2Desc": "",
      "optional3Desc": "",
      "providerColum": "",
      "nameColum": "",
      "purposeColum": "",
      "dataColum": "",
      "typeColum": ""
    }
}
export default l10n;
